// extracted by mini-css-extract-plugin
export default {"shiftedLogo":"nPNC4_77","mobile":"mobile"};